import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useTheme } from "@mui/system";
import { tokens } from "../../Theme/theme";
import TextField from "@mui/material/TextField";
import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  useMediaQuery,
} from "@mui/material";
import buzzlogo from "../../assets/cerkle_logo.png";
import login_banner from '../../assets/login_banner.png'
import { Add } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import '../../assets/fonts/fonts.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";

const theme = createTheme();


const Login = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [open, setOpen] = React.useState(false);

  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  }

  function isOriginalScreen() {

    if (isMobileScreen || isTabScreen) {
      return false
    } else {
      return true
    }
  }

  function getFlex(flex) {
    if (isMobileScreen || isTabScreen) {
      return 1
    } else {
      return flex
    }
  }


  const [severity, setseverity] = useState("");
  const [AlertMessage, setAlertMessage] = useState("");
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("")
  const HandleEmail = (e) => {
    if (errMsg) {
      setErrMsg("")
    }
    setEmail(e.target.value);
  };
  const HandlePassword = (e) => {
    if (errMsg) {
      setErrMsg("")
    }
    setPassword(e.target.value);
  };
  const navigate = useNavigate();

  const formdata = new FormData();
  const [loading, setloading] = useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem("token")
    console.log(token)

    if (token != undefined && token != null && token != "") {
      setseverity("success");
      setloading(false);
      navigate("/admin/dashboard", { replace: true });
    }
  }, [])

  const OnSubmit = async () => {
    setloading(true);
    try {

      const body = JSON.stringify({
        Email,
        Password
      })

      const response = await fetch(`${BASE_URL}/admin/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "auth-token": token,
        },
        body: body,
      });
      const json = await response.json();
      if (json.success === true) {
        setseverity("success");
        setAlertMessage(json.response);
        localStorage.setItem("token", json.token);
        setEmail("");
        setPassword("");
        handleClick();
        setloading(false);
        navigate("/admin/dashboard", { replace: true });
        return true;
      }
      if (json.success === false) {
        setseverity("warning");
        setAlertMessage(json.response);
        handleClick();
        setloading(false);

        return false;
      }
    } catch (error) {
      setErrMsg("Something went wrong!")
      setseverity("warning");
      setAlertMessage("Something went wrong!");
      handleClick();
      setloading(false);
    }
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          bgcolor: "#000000",
        }}
        display="flex"
        flexDirection={"row"}

      >


        <Box
          sx={{
            height: "100%",
            filter: 'blur(70px)',
          }}
          flex={1}
        >

          <img
            width="100%"
            height="100%"
            src={login_banner}
            style={{ objectFit: 'cover' }}
          />

        </Box>


        <Box
          sx={{
            height: "100%",
            width: "100%"
            // Apply blur to the background
          }}
          flexDirection={'column'}
          justifyContent={'center'}
          alignContent={'center'}
          display={'flex'}
          position={"absolute"}
          flex={1}
        >




          <Box
            paddingY={7}
            px={isOriginalScreen() ? 5 : 2}
            position={'absolute'}
            alignSelf={'center'}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              background: "#0e0e0e90",
              borderRadius: "40px"
            }}>


            <img
              width={80}
              height={35}
              src={buzzlogo}
              style={{ objectFit: 'contain', }}
            />


            <Typography
              marginLeft={5}
              marginTop={3}
              marginRight={5}
              sx={{ fontSize: isMobileScreen ? 22 : 32, textAlign: 'center', fontFamily: 'poppins-bold', }}
            >Welcome Back!</Typography>
            <Typography
              marginLeft={5}
              marginRight={5}
              maxWidth={isMobileScreen ? 260 : 300}
              sx={{ textAlign: 'center', fontSize: isMobileScreen ? 11 : 13, fontFamily: 'poppins-reg', color: '#ffffff50' }}
            >{"Enter your email and password to login to dashboard of cerkle."}</Typography>


            <TextField
              value={Email} type="email"
              sx={{ width: isMobileScreen ? 280 : 340, marginTop: 5, background: "#00000050", borderRadius: "5px" }}
              onChange={HandleEmail}
              InputProps={{
                sx: {
                  fontFamily: "poppins-reg",
                }
              }}
              placeholder="Email address" />

            <TextField
              value={Password} type="password"
              sx={{ width: isMobileScreen ? 280 : 340, marginTop: 2, background: "#00000050", borderRadius: "5px" }}
              onChange={HandlePassword}
              InputProps={{
                sx: {
                  fontFamily: "poppins-reg",
                }
              }}
              placeholder="Password" />

            {
              errMsg && (
                <Typography
                  marginLeft={3}
                  mt={1}
                  marginRight={3}
                  maxWidth={isMobileScreen ? 260 : 300}
                  sx={{ textAlign: 'left', fontSize: isMobileScreen ? 11 : 13, fontFamily: 'poppins-reg', color: '#fd9b08', alignSelf: "flex-start" }}
                >{errMsg}</Typography>
              )
            }



            <Button

              sx={{
                bgcolor: "#706dea",
                fontFamily: 'poppins-mid',
                textTransform: 'none',
                width: isMobileScreen ? 280 : 340,
                marginTop: 5,
                paddingY: 1.5,
                fontSize: 13,
                borderRadius: 2,
                color: '#ffffff',
              }}
              onClick={OnSubmit}
            >{loading ? "Verifying..." : "Login and Continue"}
            </Button>


          </Box>


        </Box>

      </Box>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {AlertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Login;
